import type { SxProps, Theme } from '@mui/material'

export const styles: Record<string, SxProps<Theme>> = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: ({ spacing }) => spacing(2),
  },
  markdown: {
    overflow: 'hidden',
    typography: ({ typography }) => ({
      ...typography.body1,
    }),
  },
  li: {
    display: 'list-item',
    paddingTop: 0,
    paddingBottom: 0,
  },
  ul: {
    listStyleType: 'disc',
    paddingLeft: ({ spacing }) => spacing(2),
  },
  ol: {
    listStyleType: 'decimal',
    paddingLeft: ({ spacing }) => spacing(2),
  },
}
